export enum QuestionActionType {
    BranchTo = 0,
    ComputeVariable = 1,
    ExitSurvey = 2,
    SendEmail = 3,
    SetLoopRow = 4,
    SetVariableValue = 5,
    Selection = 6,
    SetPanelistData = 7,
    ExecuteSQL = 8,
    PanelistReward = 9,
    ResumeLastSession = 10,
    CreatePanelist = 11,
    MobileAudioRecording = 12,
}
